/**
 * O PASSE COM PRAZO — o conserto do "PENSANDO" que não sai no iPad do Flávio.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * O DEFEITO, medido no registro do motor de homologação (01/09, 13:46Z)
 * ══════════════════════════════════════════════════════════════════════════
 * A pessoa toca "Gestor / Gerente". A fileira trava, o "pensando" acende, e o
 * motor NUNCA recebe o pedido: no registro do Railway daquele dia há UM único
 * turno dessa conversa (o kickoff, 1,4 s, 200) e depois zero pedidos HTTP do
 * aparelho por 15 minutos, enquanto o WebSocket do mesmo aparelho seguia
 * mandando `ping` a cada 20 s. A página estava viva; o pedido do toque não
 * existia.
 *
 * Entre o toque e o `fetch` há exatamente UMA espera: `getToken()`. E ela não
 * tinha prazo. O `getToken()` do Clerk (clerk-js 5.127, `Session.getToken`)
 * embrulha a busca do passe em `retry` com 8 tentativas e atraso inicial de
 * 3 s (fator 1,55, teto 50 s) para QUALQUER erro que não seja resposta da API
 * — o `TypeError: Load failed` do Safari em rede instável é exatamente esse
 * caso — e guarda a promessa em voo num cache compartilhado (`tokenResolver`):
 * quem chama depois espera a MESMA promessa. Em rede ruim, isso vale minutos.
 *
 * Enquanto isso, o `sendRaw` já acendeu o "pensando" e armou os vigias. O
 * vigia de silêncio dispara aos 60 s com a frase "a resposta demorou demais"
 * e etiqueta `stream_idle_timeout` — as duas CULPANDO O MOTOR por um pedido
 * que nunca saiu. Foi por isso que três sessões procuraram no lugar errado.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * O CONSERTO
 * ══════════════════════════════════════════════════════════════════════════
 * O passe tem prazo. Passou do prazo: o turno FALHA EM VOZ ALTA, agora, com a
 * frase certa ("não consegui renovar sua credencial"), a etiqueta própria
 * (`credential_wait_timeout`) e sem `fetch` nenhum — mandar sem passe daria
 * 401 e derrubaria a sessão, que é pior. A fileira destrava pelo desfecho
 * (`AcoesDoTurno`) e a pessoa toca de novo quando a rede voltar.
 *
 * Um passe que chega DEPOIS do prazo é ignorado: o turno já foi encerrado e
 * não pode nascer um pedido zumbi em cima de um turno que a tela já deu por
 * morto.
 */
export const CREDENTIAL_WAIT_TIMEOUT_MS = 10_000

type PasseComPrazo = { kind: 'token'; token: string | null } | { kind: 'timeout' }

export function aguardarPasseComPrazo(
  obterPasse: () => Promise<string | null>,
  prazoMs: number,
): Promise<PasseComPrazo> {
  return new Promise((resolve) => {
    let encerrado = false
    const relogio = setTimeout(() => {
      if (encerrado) return
      encerrado = true
      resolve({ kind: 'timeout' })
    }, prazoMs)
    obterPasse().then(
      (token) => {
        if (encerrado) return
        encerrado = true
        clearTimeout(relogio)
        resolve({ kind: 'token', token })
      },
      () => {
        // O armazém já engole a recusa e devolve `null`; se um dia deixar de
        // engolir, a recusa continua sendo "sem passe", nunca um travamento.
        if (encerrado) return
        encerrado = true
        clearTimeout(relogio)
        resolve({ kind: 'token', token: null })
      },
    )
  })
}
